import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Analytics from "../assets/AnalyticsIcn.svg";
import AnalyticsIcnRed from "../assets/AnalyticsIcnRed.svg";
import DashboardRed from "../assets/DashboardRed.svg";
import dropArroww from "../assets/dropArrow.svg";
import dropArrowwOrange from "../assets/dropArrowOrange.svg";
import HelpIcn from "../assets/HelpIcn.svg";
import HelpIcnRed from "../assets/HelpIcnRed.svg";
import OpenMenu from "../assets/menu_openWHite.svg";
import OnboadingIcn from "../assets/OnboadingIcn.svg";
import OnboadingIcnRed from "../assets/OnboadingIcnRed.svg";
import ReportIcn from "../assets/ReportIcn.svg";
import ReportIcnRed from "../assets/ReportIcnRed.svg";
import RestaurntManagIcn from "../assets/RestaurntManagIcn.svg";
import RestaurntManagIcnRed from "../assets/RestaurntManagIcnRed.svg";
import Dashboard from "../assets/sideDashblack.svg";
import StaffMangIcn from "../assets/StaffMangIcn.svg";
import StaffMangIcnRed from "../assets/StaffMangIcnRed.svg";
import SubMangeIcn from "../assets/SubMangeIcn.svg";
import SubMangeIcnRed from "../assets/SubMangeIcnRed.svg";
import Logo from "../assets/uprestroLogo.png";
import UserMangeIcn from "../assets/UserMangeIcn.svg";
import UserMangeIcnRed from "../assets/UserMangeIcnRed.svg";
import WebMangrIcn from "../assets/WebMangrIcn.svg";
import WebMangrIcnRed from "../assets/WebMangrIcnRed.svg";
import { handleLinkClick } from "../CommonJquery/CommonJquery.js";
import { retrieveData } from "../LocalConnection/LocalConnection.js";
import {
  get_admin_staffrights,
  server_post_data,
} from "../ServiceConnection/serviceconnection.js";
import { sidebarpagetext } from "./../CommonJquery/WebsiteText";
function SideBar({ isSidebarOpen, toggleSidebar }) {
  const location = useLocation();
  const access_permission = retrieveData("access_permission");
  const [page_chekt, setPage_chekt] = useState([]);
  const [rightpage, setrightpage] = useState([]);
  const [designationpage, setDesignationPage] = useState([]);
  const [isAnimating, setIsAnimating] = useState(false);
  const sidebarRef = useRef(null);

  useEffect(() => {
    // Load staff rights on initial render
    master_data_get_staff_right();
  }, []);
  // Handle overlay click to close sidebar
  const handleOverlayClick = (e) => {
    e.stopPropagation();
    if (!isAnimating) {
      toggleSidebar();
    }
  };
  // Handle sidebar animation state
  useEffect(() => {
    if (isSidebarOpen) {
      setIsAnimating(true);
      const timer = setTimeout(() => {
        setIsAnimating(false);
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [isSidebarOpen]);

  /******************* this useEffect Staff Right Activity Start****************/
  useEffect(() => {
    //console.log(page_chekt);
    //console.log(designationpage);
    var currentPage = window.location.pathname.split("/").pop();
    var rrr = Triosidebarhideshow(currentPage);
    if (rrr) {
      goback();
    }

    if (page_chekt[currentPage] && page_chekt[currentPage]["insidepage"]) {
      page_chekt[currentPage]["insidepage"].split("/").forEach(function (item) {
        console.log(item);
        const insidePages_vw = item.split("@");
        if (
          designationpage[currentPage] &&
          Object.values(designationpage[currentPage]).includes(
            insidePages_vw[0],
          )
        ) {
          // item is present in the designation so no need to remove
        } else {
          var elementsToRemove = document.querySelectorAll(
            "." + insidePages_vw[0],
          );
          elementsToRemove.forEach(function (element) {
            element.remove(); //remove buttons
          });
        }
      });
    }

    Object.keys(page_chekt).forEach(function (key) {
      var itempi = page_chekt[key].page_url_id;
      if (!designationpage[itempi]) {
        document.querySelectorAll(`li.${itempi}`).forEach(function (element) {
          element.remove();
        });
        document
          .querySelectorAll(`[href="/${itempi}"]`)
          .forEach(function (element) {
            element.remove();
          });
      }
    });
  }, [page_chekt]);

  /******************* this useEffect Staff Right Activity End ****************/

  const master_data_get_staff_right = async () => {
    const fd = new FormData();
    fd.append("flag", "10");
    await server_post_data(get_admin_staffrights, fd)
      .then((Response) => {
        // Assuming Response.data is an array of objects with 'page_url' as key
        Response.data.message.data.forEach(function (item) {
          var idd = item.page_url_id;
          setPage_chekt((prevState) => ({
            ...prevState,
            [idd]: {
              page_url_id: item.page_url_id,
              insidepage: item.insidepage,
            },
          }));
        });
        // Now you have page_chekt object in JavaScript

        const datam = access_permission.split("/");
        const newDataxt = datam.reduce((acc, item, index) => {
          if (item.includes("@")) {
            const [page, ...extras] = item.split("@");
            if (!acc[page]) {
              acc[page] = {};
            }
            extras.forEach((extra, idx) => {
              acc[page][idx] = extra;
            });
          } else {
            acc[item] = { ["class_list"]: "" };
          }
          return acc;
        }, {});
        setDesignationPage(newDataxt);

        if (Response.data.error) {
          //handleError(Response.data.message);
        } else {
          setrightpage(Response.data.message.data);
        }
      })
      .catch((error) => {});
  };

  function Triosidebarhideshow(pagelink) {
    if (designationpage[pagelink]) {
      return ""; // User has access to this page
    } else {
      if (!page_chekt[pagelink]) {
        return ""; // No user right for this page
      } else {
        return "dsplynoe"; // User has no right to access this page
      }
    }
  }

  /********* Current Page redirect Start**********/
  function goback() {
    window.history.back();
  }
  /********* Current Page redirect Close**********/
  // Smooth toggle function
  const handleToggleSidebar = () => {
    if (!isAnimating) {
      toggleSidebar();
    }
  };
  return (
    <>
      <div
        className={`sidebar-overlay ${isSidebarOpen ? "show-overlay" : ""}`}
        onClick={handleOverlayClick}
      ></div>
      <div
        ref={sidebarRef}
        className={`sidebar ${isSidebarOpen ? "OpneSidebar" : ""}`}
        style={{ willChange: "transform" }}
      >
        <div className="sidebar_container">
          <div className="sideHeadLogo">
            <div
              className="CloseSidebar"
              data-bs-toggle="tooltip"
              data-bs-placement="left"
              htmlFor="top"
              title={`Hide`}
              onClick={handleToggleSidebar}
            >
              <img
                style={{ transform: " rotate(0deg)" }}
                src={OpenMenu}
                alt="Uprestro Dashboard"
              />
            </div>
            <div
              className="headerLogo_contaienrlogo"
              onClick={() => handleLinkClick("/Dashboard")}
            >
              <img src={Logo} alt="Uprestro Dashboard" />
            </div>
          </div>
          <div className="sidebar_list">
            <ul>
              <Link to="/Dashboard">
                <li className="analytics mt-3">
                  <div
                    className={`sidebar_list_item ${
                      location.pathname === "/Dashboard"
                        ? "activeSideItem"
                        : " "
                    }`}
                  >
                    <img
                      src={
                        location.pathname === "/Dashboard"
                          ? DashboardRed
                          : Dashboard
                      }
                      alt="Uprestro Dashboard"
                    />
                    <p>{sidebarpagetext.Dashborard_text}</p>
                  </div>
                </li>
              </Link>
              <Link to="/Analytics">
                <li className="analytics">
                  <div
                    className={`sidebar_list_item ${
                      location.pathname === "/Analytics"
                        ? "activeSideItem"
                        : " "
                    }`}
                  >
                    <img
                      src={
                        location.pathname === "/Analytics"
                          ? AnalyticsIcnRed
                          : Analytics
                      }
                      alt="Uprestro Dashboard"
                    />
                    <p>Analytics</p>
                  </div>
                </li>
              </Link>
              {/**---Reports---------- */}
              <Link to="/View_Reports">
                <li
                  className={`reports sidebarDropdown ${Triosidebarhideshow(
                    "Reports",
                  )}`}
                >
                  <div
                    className={`sidebar_list_item ${
                      location.pathname === "/View_Reports"
                        ? "activeSideItem"
                        : " "
                    }`}
                  >
                    <img
                      src={
                        location.pathname === "/View_Reports"
                          ? ReportIcnRed
                          : ReportIcn
                      }
                      alt="Uprestro Dashboard"
                    />
                    <p>Reports</p>
                  </div>
                </li>
              </Link>
              <hr />
              <label className="TopHeadingtitle">Management</label>

              {/**----------------------Lede------------------- */}
              <Link onClick={() => handleLinkClick("/lead_management")}>
                <li
                  className={`guest_mngmt ${Triosidebarhideshow(
                    "Subscription_Management",
                  )}`}
                >
                  <div
                    className={`sidebar_list_item ${
                      location.pathname === "/lead_management"
                        ? "activeSideItem"
                        : " "
                    }`}
                  >
                    <img
                      src={
                        location.pathname === "/lead_management"
                          ? SubMangeIcnRed
                          : SubMangeIcn
                      }
                      alt="Uprestro Dashboard"
                    />
                    <p>Lead Mngmt</p>
                  </div>
                </li>
              </Link>
              {/**---Onboading---------- */}
              <Link onClick={() => handleLinkClick("/View_Onboading")}>
                <li
                  className={`restaurant_mngmt ${Triosidebarhideshow(
                    "Restaurant_Management",
                  )}`}
                >
                  <div
                    className={`sidebar_list_item ${
                      location.pathname === "/add_restaurant_new" ||
                      location.pathname === "/View_Onboading" ||
                      location.pathname.includes("/Edit_restaurant_new")
                        ? "activeSideItem"
                        : " "
                    }`}
                  >
                    <img
                      src={
                        location.pathname.includes("/View_Onboading")
                          ? OnboadingIcnRed
                          : OnboadingIcn
                      }
                      alt="Uprestro Dashboard"
                    />
                    <p>On-Boading Mngmt</p>
                  </div>
                </li>
              </Link>

              {/**--------------------Restaurent Management------------------------- */}
              <Link onClick={() => handleLinkClick("/View_Restaurants")}>
                <li
                  className={`restaurant_mngmt ${Triosidebarhideshow(
                    "Restaurant_Management",
                  )}`}
                >
                  <div
                    className={`sidebar_list_item ${
                      location.pathname === "/View_Restaurants"
                        ? "activeSideItem"
                        : " "
                    }`}
                  >
                    <img
                      src={
                        location.pathname === "/View_Restaurants"
                          ? RestaurntManagIcnRed
                          : RestaurntManagIcn
                      }
                      alt="Uprestro Dashboard"
                    />
                    <p>{sidebarpagetext.Restaurant_Mngmnt_text}</p>
                  </div>
                </li>
              </Link>
              {/**----------------------Subscribtion------------------- */}
              <Link onClick={() => handleLinkClick("/PlanManagement")}>
                <li
                  className={`guest_mngmt ${Triosidebarhideshow(
                    "Subscription_Management",
                  )}`}
                >
                  <div
                    className={`sidebar_list_item ${
                      location.pathname === "/PlanManagement"
                        ? "activeSideItem"
                        : " "
                    }`}
                  >
                    <img
                      src={
                        location.pathname === "/PlanManagement"
                          ? UserMangeIcnRed
                          : UserMangeIcn
                      }
                      alt="Uprestro Dashboard"
                    />
                    <p>Plan Management</p>
                  </div>
                </li>
              </Link>
              {/**----------------------Subscribtion------------------- */}
              <Link onClick={() => handleLinkClick("/View_Subsciption")}>
                <li
                  className={`guest_mngmt ${Triosidebarhideshow(
                    "Subscription_Management",
                  )}`}
                >
                  <div
                    className={`sidebar_list_item ${
                      location.pathname === "/View_Subsciption"
                        ? "activeSideItem"
                        : " "
                    }`}
                  >
                    <img
                      src={
                        location.pathname === "/View_Subsciption"
                          ? SubMangeIcnRed
                          : SubMangeIcn
                      }
                      alt="Uprestro Dashboard"
                    />
                    <p>Subscription Mngmt</p>
                  </div>
                </li>
              </Link>
            
              {/**------------------------Staff Management-------------------- */}
              <li className="dropdown sidebarDropdown staff_mngmt">
                <div
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  className={`sidebar_list_item dropdown-toggle ${
                    location.pathname === "/View_Staff" ||
                    location.pathname === "/Add_Staff" ||
                    location.pathname === "/View_Staff_Rights" ||
                    location.pathname === "/View_Sub_Rights" ||
                    location.pathname === "/View_Inside_Page_Rights" ||
                    location.pathname === "/Create_Staff_Rights" ||
                    location.pathname === "/Edit_Staff_Rights" ||
                    location.pathname === "/Edit_Sub_Rights" ||
                    location.pathname === "/Create_Inside_Page_Rights" ||
                    location.pathname === "/ViewDesignation" ||
                    location.pathname.includes("/edit_staff")
                      ? "activeSideItem"
                      : " "
                  }`}
                >
                  <img
                    src={
                      location.pathname === "/View_Staff" ||
                      location.pathname === "/Add_Staff" ||
                      location.pathname === "/View_Staff_Rights" ||
                      location.pathname === "/View_Sub_Rights" ||
                      location.pathname === "/View_Inside_Page_Rights" ||
                      location.pathname === "/Create_Staff_Rights" ||
                      location.pathname === "/Edit_Staff_Rights" ||
                      location.pathname === "/Edit_Sub_Rights" ||
                      location.pathname === "/Create_Inside_Page_Rights" ||
                      location.pathname === "/ViewDesignation" ||
                      location.pathname.includes("/edit_staff")
                        ? StaffMangIcnRed
                        : StaffMangIcn
                    }
                    alt="Uprestro Dashboard"
                  />
                  <p>{sidebarpagetext.Staff_Mgmt_text}</p>
                  <div className="droparrow">
                    <img
                      src={
                        location.pathname === "/View_Staff" ||
                        location.pathname === "/Add_Staff" ||
                        location.pathname === "/View_Staff_Rights" ||
                        location.pathname === "/View_Sub_Rights" ||
                        location.pathname === "/View_Inside_Page_Rights" ||
                        location.pathname === "/Create_Staff_Rights" ||
                        location.pathname === "/Edit_Staff_Rights" ||
                        location.pathname === "/Edit_Sub_Rights" ||
                        location.pathname === "/Create_Inside_Page_Rights" ||
                        location.pathname === "/ViewDesignation" ||
                        location.pathname.includes("/edit_staff")
                          ? dropArrowwOrange
                          : dropArroww
                      }
                      alt="img"
                    ></img>
                  </div>
                </div>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" to="/View_Staff">
                      View Staff
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/ViewDesignation">
                      Create Designation
                    </Link>
                  </li>
                </ul>
              </li>

              <Link to="/Website_Management">
                <li
                  className={`website_mngmt ${Triosidebarhideshow(
                    "Website_Management",
                  )}`}
                >
                  <div
                    className={`sidebar_list_item ${
                      location.pathname === "/Website_Management"
                        ? "activeSideItem"
                        : " "
                    }`}
                  >
                    <img
                      src={
                        location.pathname === "/Website_Management"
                          ? WebMangrIcnRed
                          : WebMangrIcn
                      }
                      alt="Uprestro Dashboard"
                    />
                    <p>{sidebarpagetext.Website_Mngmt}</p>
                  </div>
                </li>
              </Link>
              <Link to="/ViewCareer">
                <li
                  className={`website_mngmt ${Triosidebarhideshow(
                    "Website_Management",
                  )}`}
                >
                  <div
                    className={`sidebar_list_item ${
                      location.pathname === "/ViewCareer"
                        ? "activeSideItem"
                        : " "
                    }`}
                  >
                    <img
                      src={
                        location.pathname === "/ViewCareer"
                          ? WebMangrIcnRed
                          : WebMangrIcn
                      }
                      alt="Uprestro Dashboard"
                    />
                    <p>Careers</p>
                  </div>
                </li>
              </Link>

              <hr />
              <label className="TopHeadingtitle">Help</label>
              {/**----------------------------Reports-------------------------- */}

              <Link to="/Manuals">
                <li className="Manuals">
                  <div
                    className={`sidebar_list_item ${
                      location.pathname === "/Manuals" ? "activeSideItem" : " "
                    }`}
                  >
                    <img
                      src={
                        location.pathname === "/Help_And_Support" ||
                        location.pathname === "/FAQs" ||
                        location.pathname === "/Manuals"
                          ? HelpIcnRed
                          : HelpIcn
                      }
                      alt="Uprestro Dashboard"
                    />
                    <p>{sidebarpagetext.Help_Support_text}</p>
                  </div>
                </li>
              </Link>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default SideBar;
